import { backend } from "src/api";

class ScreeningApi {
  async getResults(params = {}) {
    const response = await backend.get("/screening/results", { params });
    return response.data;
  }

  /** 점수 카테고리 max(만점) 설정 — 서버와 동일한 가중치를 받아 화면 표시. */
  async getScoreConfig() {
    const response = await backend.get("/screening/score-config");
    return response.data;
  }

  async getResult(regionType, regionId, params = {}) {
    const response = await backend.get(`/screening/result/${regionType}/${regionId}`, { params });
    return response.data;
  }

  async getHistory(params = {}) {
    const response = await backend.get("/screening/history", { params });
    return response.data;
  }

  async getDates(params = {}) {
    const response = await backend.get("/screening/dates", { params });
    return response.data;
  }

  async calculate(params = {}) {
    const response = await backend.post("/screening/calculate", null, { params });
    return response.data;
  }

  async backtest(params = {}) {
    const response = await backend.post("/screening/backtest", null, { params });
    return response.data;
  }

  /** 전체 군구 상승진단 순위 조회. sidoId 없으면 전국. */
  async getRanking(params = {}) {
    const response = await backend.get("/screening/ranking", { params });
    return response.data;
  }
}

export const screeningApi = new ScreeningApi();
